<template>
    <div id="WarehouseList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Warehouse List</div>
                    <router-link v-if="canAddWarehouse" class="btn btn-primary pull-right" v-bind:to="{name: 'WarehouseCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content warehouse-list">
                        <data-table-filter-config :moduleName="'warehouseList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'warehouseList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listWarehouseTable"
                                    mode="remote"
                                    title="Warehouse"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: warehouse_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateWarehouse">
                                                    <router-link title="Edit Warehouse" class="fp-edit" v-bind:to="{name: 'WarehouseEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="warehouse_value" id="deleteWarehouseBtn" v-on:click.prevent="WarehouseDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "WarehouseList",
        metaInfo() {
            return {title: "Warehouse List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
             permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warehouse Type',
                    field: 'type',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Warehouse Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Distribution Point',
                    field: 'distribution_point',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Distribution Point", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warehouse Default',
                    field: 'is_default',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Select Warehouse Default", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes', 'No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            warehouse_value: false,
            loading:false,
            canAddWarehouse:false,
            canUpdateWarehouse:false
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_warehouse') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_warehouse') {
                            self.canAddWarehouse = true;
                            self.canUpdateWarehouse = true;
                        }
                        if (permissions[i].name == 'delete_warehouse') {
                            self.warehouse_value = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listWarehouseTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('is_default');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.is_default) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/warehouse/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'warehouse-list')
                    }
                });
            },
            WarehouseDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Warehouse?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listWarehouseTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listWarehouseTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteWarehouseBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/warehouse/delete",
                          type: "POST",
                          data: 'id=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteWarehouseBtn").val("Delete");
                              }, 10000);
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,true,'warehouse-delete')
                          }
                      });
                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Warehouse? ')) {
                // }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/warehouse/WarehouseList.vue